import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

const PipelinesRepoDeploymentsPageLoadable = Loadable<any, any>({
  loading: LoadingPage,
  loader: () => import('./deployments'),
});

// eslint-disable-next-line import/no-default-export
export default PipelinesRepoDeploymentsPageLoadable;
